import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig, footerPrivacy, footerDisclaimer } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { label: 'Home', href: '#hero' },
    { label: 'Services', href: '#services' },
    { label: 'How We Help', href: '#how-we-help' },
    { label: 'About', href: '#about' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <footer
      id="footer"
      className="relative pt-16 pb-8"
      style={{ backgroundColor: '#162B48' }}
    >
      {/* Top gradient border */}
      <div
        className="absolute top-0 left-0 right-0 h-1"
        style={{ background: 'linear-gradient(90deg, transparent, #D6A94F, transparent)' }}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main footer content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand column */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="/logo-original.png"
                alt="Pacific Crest Properties Logo"
                className="h-12 w-auto"
              />
              <div>
                <span className="font-display font-semibold text-lg text-white">
                  Pacific Crest Properties
                </span>
              </div>
            </div>

            <p className="text-white/70 font-display text-xl mb-1">
              {siteConfig.slogan}
            </p>
            <p className="text-white/70 font-display text-xl mb-6">
              {siteConfig.sloganLine2}
            </p>

            <p className="text-white/50 text-sm leading-relaxed max-w-md">
              A modern real estate solutions company helping Los Angeles homeowners make confident property decisions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/60 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-5">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={`tel:${siteConfig.phone.replace(/[^0-9]/g, '')}`}
                  className="text-white/60 hover:text-white transition-colors duration-300"
                >
                  {siteConfig.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${siteConfig.email}`}
                  className="text-white/60 hover:text-white transition-colors duration-300"
                >
                  {siteConfig.email}
                </a>
              </li>
              <li className="text-white/60">
                {siteConfig.address.street}<br />
                {siteConfig.address.city}, {siteConfig.address.state} {siteConfig.address.zip}
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8 mt-8">
          {/* Privacy text */}
          <div className="mb-6 text-center">
            <p className="text-white/40 text-xs leading-relaxed max-w-3xl mx-auto">
              {footerPrivacy}
            </p>
            <p className="text-white/40 text-xs leading-relaxed max-w-3xl mx-auto mt-3 italic">
              {footerDisclaimer}
            </p>
          </div>

          {/* Legal links */}
          <div className="flex items-center justify-center gap-4 mb-6 text-sm">
            <Link
              to="/privacy-policy"
              className="text-white/50 hover:text-white transition-colors duration-300"
            >
              Privacy Policy
            </Link>
            <span className="text-white/30">|</span>
            <Link
              to="/terms-and-conditions"
              className="text-white/50 hover:text-white transition-colors duration-300"
            >
              Terms &amp; Conditions
            </Link>
          </div>

          {/* Bottom bar */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/40 text-sm">
              © {currentYear} Pacific Crest Properties. All rights reserved.
            </p>
            <div className="text-center sm:text-right">
              <p className="text-white/50 text-sm font-display">
                {siteConfig.slogan}
              </p>
              <p className="text-white/50 text-sm font-display">
                {siteConfig.sloganLine2}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
